// extracted by mini-css-extract-plugin
module.exports = {"couponContainer":"_3ctoB","headerTitle":"_3Gmkr","headerSubtitle":"MvXAS","couponText":"_3Z569"};